import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { IconButton, TextField } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import BaseElement from './BaseElement'
import { getPropertyName } from '../../helpers/utils'
import { ImageSearch } from '@mui/icons-material'

const ImageMutator = ({ definition, value, path, parent, itemKey, buttons }) => {
  const dispatch = useDispatch()
  const imageMutatorValue = useSelector(state => state.imageMutatorValue)
  const [controlledValue, setValue] = useState(value)
  const title = useMemo(() => getPropertyName(definition?.title, itemKey), [definition, itemKey])

  const handleInputChange = useCallback((event) => {
    const newValue = event.target.value
    setValue(newValue)
    parent.set(itemKey, newValue)
  }, [parent, itemKey])

  const handleOpenAssetModal = useCallback(() => dispatch({
    type: 'open-assets',
    data: { isOpen: true, showSelection: true, path }
  }), [dispatch, path])

  useEffect(() => {
    if (path === imageMutatorValue?.path) {
      setValue(imageMutatorValue?.value)
      parent.set(itemKey, imageMutatorValue?.value)
    }
  }, [imageMutatorValue?.path, imageMutatorValue?.value, path, parent, itemKey])

  return (
    <BaseElement error={!definition}>
      <header-area>
        <span>{title}</span>
        <div>
          {buttons}
          <IconButton size="small" onClick={handleOpenAssetModal}><ImageSearch /></IconButton>
        </div>
      </header-area>
      <TextField
        value={controlledValue}
        size='small'
        multiline
        fullWidth
        minRows={1}
        maxRows={10}
        style={{ flexGrow: 1 }}
        error={!definition}
        onChange={handleInputChange}
      />
    </BaseElement>
  )
}

export default ImageMutator